import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
    ]
    },
    lastname: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    eventdate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    theme: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    EventExtra1: {
      validations: []
      },
    SiteName: {
      validations: []
    },
    reference: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address:*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:*',
            mapping: 'telnumber'
          }
        ]
      },

      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'eventdate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'What Type of Event Are You Hosting?:',
            options: [
              { label: 'Baby Shower', value: 'Baby Shower' },
              { label: 'Birthday', value: 'Birthday' },
              { label: 'Corporate', value: 'Corporate' },
              { label: 'Design', value: 'Design' },
              { label: 'Family', value: 'Family' },
              { label: 'Non-Profit', value: 'Non-Profit' },
              { label: 'Party', value: 'Party' },
              { label: 'Wedding', value: 'Wedding' },
              { label: 'Other', value: 'Other' },
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Guest Count:',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Budget:',
            mapping: 'EventExtra1'
          }
        ]
      },
       {
            fields: [
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Venue Name:',
            options: [
              { label: 'Balducci Vineyards', value: 'Balducci Vineyards'},
              { label: 'Best Western Plus Expo Center', value: 'Best Western Plus Expo Center'},
              { label: 'Blumenhof Winery', value: 'Blumenhof Winery'},
              { label: 'Boone Monument Village', value: 'Boone Monument Village'},
              { label: 'Elijah McLean’s', value: 'Elijah McLean’s'},
              { label: 'Elks Lodge', value: 'Elks Lodge'},
              { label: 'Historic John G. Busch Brewery Event Center', value: 'Historic John G. Busch Brewery Event Center'},
              { label: 'Jesuit Hall', value: 'Jesuit Hall'},
              { label: 'Knights of Columbus Hall', value: 'Knights of Columbus Hall'},
              { label: 'Knotting Hills', value: 'Knotting Hills'},
              { label: 'Little Piney', value: 'Little Piney'},
              { label: 'Lost Hill Lake', value: 'Lost Hill Lake'},
              { label: 'Mount Pleasant Winery', value: 'Mount Pleasant Winery'},
              { label: 'Noboleis Vineyards', value: 'Noboleis Vineyards'},
              { label: 'Oak and Front', value: 'Oak and Front'},
              { label: 'Pine Hallow Farms', value: 'Pine Hallow Farms'},
              { label: 'Preserve Marthasville', value: 'Preserve Marthasville'},
              { label: 'Renaissance Wine Gardens', value: 'Renaissance Wine Gardens'},
              { label: 'Riverbend Chapel', value: 'Riverbend Chapel'},
              { label: 'Stone House of St. Charles', value: 'Stone House of St. Charles'},
              { label: 'Sunset Bluffs', value: 'Sunset Bluffs'},
              { label: 'The Reserve at Augusta', value: 'The Reserve at Augusta'},
              { label: 'The Venue at Maison du Lac ', value: 'The Venue at Maison du Lac '},
              { label: 'The White Owl', value: 'The White Owl'},
              { label: 'TRINITY HALL AT TRIPLE 3 VINEYARD', value: 'TRINITY HALL AT TRIPLE 3 VINEYARD'},
              { label: 'Wild Carrot', value: 'Wild Carrot'},
              { label: 'Wildflower Ridge', value: 'Wildflower Ridge'},
              { label: 'Unknown/Undecided', value: 'Unknown/Undecided'},
              { label: 'Personal Residence', value: 'Personal Residence'},
              { label: 'Other - Please add details below', value: 'Other - Please add details below'},
            ],
                mapping: 'SiteName'
              }
            ]
          },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: 'How did you hear about us?:',
            options: [
              { label: 'Sunset Bluffs Website', value: 'Sunset Bluffs Website' },
              { label: 'Google', value: 'Google' },
              { label: 'Facebook', value: 'Facebook' },
              { label: 'Instagram', value: 'Instagram' },
              { label: 'The Knot', value: 'The Knot' },
              { label: 'Yelp', value: 'Yelp' },
              { label: 'Missourian', value: 'Missourian' },
              { label: 'Friend/Family', value: 'Friend/Family' },
              { label: 'Pinterest', value: 'Pinterest' },
              { label: 'Wedding Wire', value: 'Wedding Wire' },
              { label: 'Client/Vendor Referral', value: 'Client/Vendor Referral' },
              { label: 'Other', value: 'Other' },
            ],
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Any Additional Details About Your Event?:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Cafe Mosaic Event Contact Form',
    formId: '2087',
    clientKey: 'F93E8C9F-38C2-4D48-A600-AF94B852A824',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    submissionText: 'Thank you! Your request has been received. Our catering coordinator will reach out to you within 24 business hours.',
    redirectUrl: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
